import { TIME_LINE_CHUNKS } from "@shared/constants";
import { OptionWithData } from "@shared/interfaces";

export const PATIENT_SCALE_OPTIONS: OptionWithData<number, TIME_LINE_CHUNKS>[] = [
  {
    label: "5 min",
    value: TIME_LINE_CHUNKS.FIVE_MINUTES,
    data: 5 * 60 * 1000,
  },
  {
    label: "30 min",
    value: TIME_LINE_CHUNKS.THIRTY_MINUTES,
    data: 30 * 60 * 1000,
  },
  {
    label: "3 hrs",
    value: TIME_LINE_CHUNKS.THREE_HOURS,
    data: 3 * 60 * 60 * 1000,
  },
  {
    label: "8 hrs",
    value: TIME_LINE_CHUNKS.EIGHT_HOURS,
    data: 8 * 60 * 60 * 1000,
  },
  {
    label: "12 hrs",
    value: TIME_LINE_CHUNKS.TWELVE_HOURS,
    data: 12 * 60 * 60 * 1000,
  },
];

export const PATIENT_AVG_SCALE_OPTION: OptionWithData<number, TIME_LINE_CHUNKS> = {
  label: "14 days",
  value: TIME_LINE_CHUNKS.SEVEN_DAYS,
  data: 14 * 24 * 60 * 60 * 1000,
};

export const DAILY_CHART_LEGENDS_RR: { name: string; type: "line" | "circle"; color: string }[] = [
  { color: "#3491E3", name: "RR Stable Period", type: "line" },
  { color: "#82ca9d", name: "RR Average", type: "line" },
  { color: "#E3345E", name: "Notifications", type: "circle" },
];

export const DAILY_CHART_LEGENDS_HR: { name: string; type: "line" | "circle"; color: string }[] = [
  { color: "#3491E3", name: "HR Stable Period", type: "line" },
  { color: "#82ca9d", name: "HR Average", type: "line" },
  { color: "#E3345E", name: "Notifications", type: "circle" },
];

export const CHART_LEGENDS_RR: { name: string; type: "line" | "circle" | "dash-dot"; color: string }[] = [
  { color: "#F2699A", name: "RR", type: "line" },
];

export const CHART_LEGENDS_HR: { name: string; type: "line" | "circle" | "dash-dot"; color: string }[] = [
  { color: "#F2699A", name: "HR", type: "line" },
];
